import { render } from "./KitPrintMonitorModel.vue?vue&type=template&id=3ebb1a67"
import script from "./KitPrintMonitorModel.vue?vue&type=script&lang=js"
export * from "./KitPrintMonitorModel.vue?vue&type=script&lang=js"

import "./KitPrintMonitorModel.vue?vue&type=style&index=0&id=3ebb1a67&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__